module.exports = __webpack_public_path__ + "static/media/1009822.ccc07b52.jpg";